import { render, staticRenderFns } from "./div-manager.vue?vue&type=template&id=9b035508&scoped=true"
import script from "./div-manager.vue?vue&type=script&lang=js"
export * from "./div-manager.vue?vue&type=script&lang=js"
import style0 from "./div-manager.vue?vue&type=style&index=0&id=9b035508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b035508",
  null
  
)

export default component.exports